import type { IntegrityStatus } from "~utils/moduleIntegrity";

interface TableOfContentsTitleIntegrityProps {
    date: string;
}

export default function integrityCheck({
    date,
}: TableOfContentsTitleIntegrityProps): IntegrityStatus {
    const messages: string[] = [];

    if (!date || date === "") {
        messages.push("Invalid date");
    }

    return messages;
}
